export enum UserTypes {
  USER = 'user',
  EDITOR = 'editor',
  ADMIN = 'admin',
  SUPERADMIN = 'superadmin',
  ACTIVE = 'active',
}

export const FORBIDDEN_ERROR =
  'Please check your Workday profile with your local People Admin team';
